import { Tab } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosOrdenTrabajoEnumChoice,
  a11yProps,
  useCheckPermissions,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
// import OperacionInstallPrerechazadaTecOTPage from '../OperacionInstallPrerechazadaTecOTPage';
import { InstallTecnicoOTByState } from '@/erp/tecnico/orden-trabajo/pages';

export type OperacionTecnicoInstallMainPageProps = {};



const OperacionTecnicoInstallMainPage: React.FC<
  OperacionTecnicoInstallMainPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  const { handleMethodChange, valueTab } = useTabsFormOnly();

  return (
    <SingleTableBoxScene title={'Instalaciones'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          {/* <Tab label="Asignadas" value={1} {...a11yProps(1)} /> */}
          <Tab label="Asignadas Recoordinadas" value={1} {...a11yProps(1)} />
          {/* <Tab label="Pendientes Actualizar" value={3} {...a11yProps(3)} /> */}
          <Tab label="Realizadas" value={2} {...a11yProps(2)} />
          {/* <Tab label="Realizadas Actualizadas" value={5} {...a11yProps(5)} /> */}
          {/* <Tab label="Pre Rechazadas" value={3} {...a11yProps(3)} /> */}
          <Tab label="Fallidas" value={4} {...a11yProps(4)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Asignadas ============ */}
      {/* <CustomTabPanel value={valueTab} index={1}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.EN_ESPERA}
        />
      </CustomTabPanel> */}

      {/* ============ Asignadas Recoordinadas ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <InstallTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
        />
      </CustomTabPanel>

      {/* ============ Pendientes Actualizar ============ */}
      {/* <CustomTabPanel value={valueTab} index={3}>
        PENDIENTES ACTUALIZAR
      </CustomTabPanel> */}

      {/* ============ Realizadas ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <InstallTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.REALIZADA}
        />
      </CustomTabPanel>

      {/* ============ Realizadas Actualizadas ============ */}
      {/* <CustomTabPanel value={valueTab} index={5}>
        REALIZADAS ACTUALIZADAS
      </CustomTabPanel> */}

      {/* ============ Pre Rechazadas ============ */}
      {/* <CustomTabPanel value={valueTab} index={3}>
        <OperacionInstallPrerechazadaTecOTPage />
      </CustomTabPanel> */}

      {/* ============ Rechazadas ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <InstallTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.RECHAZADA}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default OperacionTecnicoInstallMainPage;
